import React, { useState, useEffect } from 'react'
import { Box, Paper, Loader, Text, Select } from '@mantine/core'
import { AreaChart } from '@mantine/charts'
import { getDataStatsUser } from '../../../services/dashboard'
import classes from '../../../assets/module-css/AdminLayout.module.css'

const defaultRangeStats = [
  {
    label: 'Daily',
    value: 'DAILY'
  },
  {
    label: 'Weekly',
    value: 'WEEKLY'
  },
  {
    label: 'Monthly',
    value: 'MONTHLY'
  },
]

const DashboardStatisticUser = () => {
  const [loadingStatistic, setLoadingStatistic] = useState(true)
  const [statsUser, setStatsUser] = useState([])
  const [selectedRange, setSelectedRange] = useState('DAILY')

  const handleGetStatsUser = async () => {
    setLoadingStatistic(true)
    try {
      const response = await getDataStatsUser(selectedRange)
      if (response?.data) {
        const responseStats = response.data.userSessionStats
        setStatsUser(responseStats)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingStatistic(false)
    }
  }

  useEffect(() => {
    handleGetStatsUser()
    // eslint-disable-next-line
  }, [selectedRange])

  const loadingDataStats = () => {
    return (
      <Box ta='center' my={120}>
        <Loader size='sm' />
        <Text c='gray.6' fz={14}>Loading Data</Text>
      </Box>
    )
  }

  const loadLayoutStats = () => {
    return (
      <Box>
        <AreaChart
          h={250}
          data={statsUser}
          dataKey='label'
          series={[
            {
              name: 'count',
              label: 'Active User',
              color: 'red'
            }
          ]}
          curveType="natural"
          tickLine="xy"
          gridAxis="xy"
        />
      </Box>
    )
  }


  return (
    <Paper shadow="sm" p='md' withBorder radius='md' my='lg'>
      <Text className={classes.titleLayout} mb='md'>{defaultRangeStats.find((val) => val.value === selectedRange).label} Active User</Text>
      <Box>
        <Select
          name='active'
          value={selectedRange}
          data={defaultRangeStats}
          onChange={setSelectedRange}
          size='xs'
          allowDeselect={false}
          w={150}
        />
      </Box>
      <Box my={20}>
        {loadingStatistic ? loadingDataStats() : loadLayoutStats()}
      </Box>
    </Paper>
  )
}

export default DashboardStatisticUser